<template>
  <div class="headers">
    <div class="header-content">
      <span class="logo">
      <a href="/indexs"><img src="../../assets/img/logos.png" alt="" ></a>
    </span>
<!--      <div>-->
<!--              <el-input placeholder="请输入搜索信息" v-model="keyword" class="input-with-select header-input" >-->
<!--                <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>-->
<!--              </el-input>-->
<!--            </div>-->
      <div class="header-right">
        <span style="font-size: 16px;line-height: 40px;color: #fff;margin-right: 20px"> <i class="iconfont iconkefu" style="margin-right: 6px"></i>服务电话：400-999-6541 </span>
<!--        <a :href="'https://www.emof.cn/tiaoz?code='+allToken + '&path=/st/setup'" target="_blank" class="line-btn" style="margin-left: 20px;">-->
<!--            机构设置-->
<!--        </a>-->


<!--        <a href="javascript:void 0" @click="toPage('/msg',false)" class=" line-btn">-->
<!--          消息中心-->
          <!--        <i class="iconfont iconlingdang lingdang" ></i>-->
          <!-- (<span>{{news}}</span>)     <em class="dian" v-if="show"></em> -->
<!--        </a>-->

<!--        <a href="javascript:void 0" @click="toPage('/help',false)" class=" line-btn">帮助中心</a>-->

<!--        <el-dropdown>-->
<!--          <div class="navItem">-->
<!--            <img :src="img"><span style="margin-right: 5px;">{{name}}</span>帐号管理<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--          </div>-->
<!--          <el-dropdown-menu slot="dropdown">-->
<!--            <el-dropdown-item @click.native="toPage('/user',false)">帐号管理</el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="toPage('/accUp',false)">帐号升级</el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="toPage('/login',true)">退出登录</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
          <div class="header-operate flex flex-direction align-center justify-center" @click="toPage('/help',true)">
              <i class="icon el-icon-question"></i>
              <div class="label">帮助中心</div>
          </div>
          <div class="header-operate flex flex-direction align-center justify-center" @click="toPage('/login',true)">
              <i class="icon iconfont iconguanji"></i>
              <div class="label">退出登录</div>
          </div>
          <el-link class="header-operate yellow" :href="'https://www.emof.cn/vw/tiaoz?code='+allToken + '&path=/home'" :underline="false" target="_blank">
              <div class="label">访问首页</div>
          </el-link>
<!--        <a href="javascript:void 0" class="navItem" @click="toPage('/login',true)"><i class="iconfont iconguanji" style="font-size: 18px"></i></a>-->

<!--        <a :href="'https://www.emof.cn/vw/tiaoz?code='+allToken + '&path=/home'" class="to-emof">-->
<!--          <span class="el-link&#45;&#45;inner"><div data-v-0a1b0f78="" class="title">访问首页</div><div data-v-0a1b0f78="" class="tips">免费获取更多实用工具</div></span>-->
<!--        </a>-->
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        keyword:'', //  关键字
        msgNum: 0,  //  消息数量
        img:'',
        name:'',
        news:3,
        show:true,
        allToken:this.$store.state.allToken
      }
    },
    created(){
      console.log(this.$store.state)
      this.img = this.$store.state.userMthumb
      this.name = this.$store.state.userName
    },
    methods:{
      toSearch(){

        if(!this.keyword) return
        this.$router.push({
          path:'/home/repositoriesSearch/' + this.keyword,
        })
      },
      toPage(route,state){
        if(state){
          this.$confirm('是否退出登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.state.userMid = null
            this.$store.state.userName = null
            this.$store.state.userMthumb = null
            this.$store.state.userRoleid = null
            this.$store.state.allToken = null
            this.$router.push('/login')
            this.$message({
              type: 'success',
              message: '退出成功'
            })
          }).catch(() => {
          })
        }else{
          this.$router.push(route)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.headers{
  height: 100px;
  background: #0a2240;
  .header-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*width: 1200px;*/
    height: 100px;
    padding: 0 20px;
    margin: 0 auto;
    .logo{
      display: flex;
      align-items: center;
      font-size: 24px;
      line-height: 60px;
      color: #fff;
      a{
        img{
          height: 50px;
        }
      }
    }
    .header-right{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .navItem{
        height: 60px;
        line-height: 60px;
        margin: 0 10px;
        color: #fff;
        font-size: 16px;
        /*min-width: 100px;*/
        text-align: center;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
          border-radius: 30px;
          margin-right: 5px;
        }
        .toemof{
          width: 150px;
          height: 44px;
        }
        .lingdang{
          font-size: 20px;
          vertical-align: middle;
          position:relative;
          margin-right:8px;
        }
        .dian{
          position: absolute;
          top: 0px;
          right: 3px;
          width: 6px;
          height:6px;
          background-color: #ffe400;
          border-radius: 50%;
          overflow: hidden;
        }
      }
    }
  }

}
</style>
